import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-usage-hint',
  templateUrl: './usage-hint.component.html',
  styleUrls: ['./usage-hint.component.scss']
})
export class UsageHintComponent {

  @Input()
  iconName: string;
  @Input()
  line1: string;
  @Input()
  line2?: string;
  @Input()
  bigIcon: boolean = false;

}
